import { render, staticRenderFns } from "./SwitchOrg.vue?vue&type=template&id=39801f7a"
import script from "./SwitchOrg.vue?vue&type=script&lang=js"
export * from "./SwitchOrg.vue?vue&type=script&lang=js"
import style0 from "./SwitchOrg.vue?vue&type=style&index=0&id=39801f7a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VBtn,VDivider,VSkeletonLoader})
